// __stubs__/suprsend-inbox.js
//
// Dev/build runtime stub for @suprsend/react-inbox.
//
// @suprsend/react-inbox@3.9.0 (latest on npm at the time of EP-10) declares
// peerDependencies.react ">= 16.8.0" but its compiled output references
// ReactSharedInternals.ReactCurrentDispatcher — a private React internal
// removed in React 19 — and crashes at module load. That crash blanks the
// app. This stub is aliased in vite.config.ts via `resolve.alias` so the
// rest of the app boots while the upstream package catches up to React 19.
//
// Symptom that triggered this stub:
//   TypeError: undefined is not an object (evaluating
//     'ReactSharedInternals.ReactCurrentDispatcher')
//
// Remove this stub (and the alias) once @suprsend/react-inbox ships a
// React-19-compatible release, or after the dep is replaced.

import * as React from "react";

const SuprSendInbox = () => React.createElement("div", { "data-suprsend-stub": true });

export default SuprSendInbox;
